import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllUnidadeMedidaConversaoCadastro } from '../service';
import {
  LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO,
  LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING,
  LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS,
  LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllUnidadeMedidaConversaoCadastro(action) {
  yield put({ type: LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING })

  try {
    const list = yield call(findAllUnidadeMedidaConversaoCadastro)
    
    yield put({ type: LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllUnidadeMedidaConversaoCadastro() {
  yield takeLatest(LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO, sagaListAllUnidadeMedidaConversaoCadastro)
}